import React, { useState, useEffect, useReducer } from 'react';
import { Container, Button, FormHelperText, TextField, OutlinedInput, Select, FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { withAuthenticator, SignIn, ConfirmSignIn, RequireNewPassword } from 'aws-amplify-react';
import { API, graphqlOperation } from 'aws-amplify';
import { listUsers } from '../../../graphql/queries'
import { searchUsers, customSearchUsers } from '../../../graphql/queries'
import { createUserListCsv } from '../../../graphql/mutations'
import './UserListPage.scss'
import * as moment from 'moment'
import useForm from '../../../infrastructure/FormLib';
import UserList from '../../../components/admin/user-list/UserList';
import MomentUtils from '@date-io/moment';
import {
    MuiPickersUtilsProvider,
    DatePicker,
} from '@material-ui/pickers';
import CircularProgress from '@material-ui/core/CircularProgress';
import { throttle } from 'lodash';
import AdminMenu from '../../../components/admin/admin-menu/AdminMenu';

import ClearIcon from "@material-ui/icons/Clear";


function UserListReport(props) {
    const [totalRecords, setTotalRecords] = useState(null);
    const [userList, setUserList] = useReducer((originalValue, newValue) => {
        if (newValue.action === 'concat') {
            let newArray = originalValue.concat(newValue.value);
            return newArray;
        }
        return newValue.value;

    }, []);
    const [isDownloading, setIsDownloading] = useState(false)
    const [isStateInit] = useState(false);

    const stateSchema = {
        name: { value: '', error: '' },
        contact: { value: '', error: '' },
        email: { value: '', error: '' },
        join_date_from: { value: null, error: '' },
        join_date_to: { value: null, error: '' },
        language: { value: 'All', error: '' },
        payment_status: { value: 'All', error: '' },
    };
    const validationStateSchema = {
        contact: {
            required: false,
            requiredErrorMsg: 'ID Type is required'
        },
        name: {
            required: false,
            requiredErrorMsg: 'Name is required'
        },
        join_date_from: {
            required: false,
            requiredErrorMsg: 'Date of Attendance is required'
        },
        join_date_to: {
            required: false,
            requiredErrorMsg: 'Date of Attendance is required'
        },
        email: {
            required: false,
            requiredErrorMsg: 'Email is required',
        },
        language: {
            required: false,
            requiredErrorMsg: 'Language is required',
        },
        payment_status: {
            required: false,
            requiredErrorMsg: '',
        },
    };

    const [filterParameter, setFilterParameter] = useReducer((originalValue, newValue) => {
        return newValue
    }, {});

    const [currentFilterParams, setCurrentFilterParams] = useReducer((originalValue, newValue) => {
        return newValue;
    }, {
        'fullname': '',
        'email': '',
        'contact': '',
        'joinDateFrom': '',
        'joinDateTo': '',
        'language': 'All'
    });

    const [sortParameter, setSortParameter] = useState({
        field: 'createdAt',
        direction: 'desc'
    })

    const [joinDateSort, setJoinDateSort] = useState(false)
    const [nextToken, setNextToken] = useReducer((originalValue, newValue) => {
        return newValue;
    }, null)
    const [isPageEnd, setIsPageEnd] = useState(false)

    const { state, handleOnChange, setState } = useForm(
        stateSchema,
        validationStateSchema,
        submit
    );

    function handleChanges(event) {
        setIsFilterClicked(false)
        handleOnChange(event)
    }

    function filterOnFocus() {
        setIsFilterClicked(false)
    }
    function submit() { }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!isStateInit) {
            setFilterParameter(null)
        }
    }, [isStateInit]);

    useEffect(() => {
        setUserList({ action: 'assign', value: [] })
        setNextToken(null)
        fetchUserList(false)
    }, [filterParameter])
    const [additionalRecordList, setAdditionalRecordList] = useState([])

    useEffect(() => {
        if (!nextToken && additionalRecordList.length <= 0) {
            setIsPageEnd(true)
        }
        else {
            setIsPageEnd(false)
        }
    }, [additionalRecordList.length, nextToken]);

    const [isFilterClicked, setIsFilterClicked] = useState(true)
    const [currentToken, setCurrentToken] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [joinFromDate, setJoinFromDate] = useState('')
    const [joinToDate, setJoinToDate] = useState('')
    async function fetchUserList(isUpdate, passInSortParam) {
        if (isLoading) {
            return
        }
        setTotalRecords(null);
        setIsLoading(true)
        let params = {
            limit: 50,
        };
        if (isUpdate) {
            params.nextToken = userList.length
            // params.nextToken = nextToken;
        }

        if (filterParameter && Object.entries(filterParameter).length !== 0) {
            params.filter = filterParameter;
        }

        if (passInSortParam && Object.entries(passInSortParam).length !== 0) {
            params.sort = passInSortParam
        }
        else if (sortParameter && Object.entries(sortParameter).length !== 0) {
            params.sort = sortParameter
        }

        try {
            let response = await API.graphql(graphqlOperation(customSearchUsers, params))
            let currentToPush = []
            if (response.data.customSearchUsers) {
                // let last_item = response.data.customSearchUsers.items[response.data.customSearchUsers.items.length - 1] 
                setNextToken((isUpdate ? userList.length : 0) + response.data.customSearchUsers.items.length === response.data.customSearchUsers.total ? null : 'a')
                setTotalRecords(response.data.customSearchUsers.total);
                // setNextToken(response.data.customSearchUsers.nextToken)
                // response.data.customSearchUsers.items.map((record, index) => {
                //     currentToPush.push(record)
                // })
                if (isUpdate) {
                    setUserList({ action: 'concat', value: response.data.customSearchUsers.items });
                }
                else {
                    setUserList({ action: 'assign', value: response.data.customSearchUsers.items });
                }
            }
        }
        catch (error) { }

        setIsLoading(false)
    }
    // async function fetchUserList(isUpdate) {
    //     if (isLoading) {
    //         return
    //     }
    //     setIsLoading(true)

    //     let pagination = 50;
    //     let currentRecordCount = 0;
    //     let currentToPush = []
    //     let currentAdditionalRecordList = []
    //     let current_currentToken = currentToken
    //     let current_nextToken = nextToken
    //     let isFirstTime = true
    //     try {
    //         if (additionalRecordList.length <= 5) {
    //             currentRecordCount = additionalRecordList.length;
    //             currentToPush = additionalRecordList;
    //         }
    //         else {
    //             additionalRecordList.map((record, index) => {
    //                 if (currentRecordCount != pagination) {
    //                     currentToPush.push(record)
    //                     currentRecordCount += 1;
    //                 }
    //                 else {
    //                     currentAdditionalRecordList.push(record)
    //                 }
    //             })

    //         }
    //         setAdditionalRecordList([]);

    //         while (currentAdditionalRecordList.length <= 0) {
    //             let params = {
    //                 sort: {
    //                     field: 'createdAt',
    //                     direction: 'desc'
    //                 },
    //                 limit: 100,
    //             };

    //             if (isUpdate && isFirstTime) {
    //                 if (current_nextToken === null) {
    //                     break;
    //                 }
    //                 params.nextToken = current_nextToken;
    //             }
    //             else {
    //                 if (!isFirstTime) {
    //                     params.nextToken = current_nextToken
    //                 }
    //             }
    //             isFirstTime = false
    //             if (filterParameter && Object.entries(filterParameter).length !== 0) {
    //                 params.filter = filterParameter;
    //             }

    //             let response = await API.graphql(graphqlOperation(customSearchUsers, params))

    //             current_currentToken = current_nextToken
    //             current_nextToken = response.data.customSearchUsers.nextToken
    //             if (response.data.customSearchUsers) {
    //                 response.data.customSearchUsers.items.map((record, index) => {
    //                     if (currentRecordCount != pagination) {
    //                         currentToPush.push(record)
    //                         currentRecordCount += 1;
    //                     }
    //                     else {
    //                         currentAdditionalRecordList.push(record)
    //                     }
    //                 })
    //             }
    //             if (current_nextToken === null) {
    //                 break;
    //             }
    //         }

    //         setCurrentToken(current_currentToken)
    //         setNextToken(current_nextToken)
    //         setAdditionalRecordList(currentAdditionalRecordList);

    //         if (isUpdate) {
    //             setUserList({ action: 'concat', value: currentToPush });
    //         }
    //         else {
    //             setUserList({ action: 'assign', value: currentToPush });
    //         }
    //         setIsLoading(false)

    //     } catch (error) {
    //         setIsLoading(false)
    //     }
    // }

    function isDateFormat(value) {
        return moment.isDate(new Date(value));
    }

    function onJoinDateFromChanged(momentObj) {
        if (!momentObj) {
            let event = {
                target: {
                    name: 'join_date_from',
                    value: null
                }
            }
            handleChanges(event)
        }
        else if (!momentObj.target) {
            let event = {
                target: {
                    name: 'join_date_from',
                    value: momentObj
                }
            }
            setJoinFromDate(momentObj)
            handleChanges(event)
        }
        else if (momentObj) {
            let event = {
                target: {
                    name: 'join_date_from',
                    value: state.join_date_from.value
                }
            }
            handleChanges(event)
        }
    }

    function onJoinDateToChanged(momentObj) {
        if (!momentObj) {
            let event = {
                target: {
                    name: 'join_date_to',
                    value: null
                }
            }
            handleChanges(event)
        }
        else if (!momentObj.target) {
            let event = {
                target: {
                    name: 'join_date_to',
                    value: momentObj
                }
            }
            setJoinToDate(momentObj)
            handleChanges(event)
        }
        else if (momentObj) {
            let event = {
                target: {
                    name: 'join_date_to',
                    value: state.join_date_to.value
                }
            }
            handleChanges(event)
        }
    }

    const [operationErrorNotification, setOperationErrorNotification] = useState('')

    useEffect(() => {
        setOperationErrorNotification('')
        if (state.join_date_from.value && !state.join_date_to.value) {
            setOperationErrorNotification('Both join date from and join date to is required to filter by date range')
        }
        else if (state.join_date_to.value && !state.join_date_from.value) {
            setOperationErrorNotification('Both join date from and join date to is required to filter by date range')
        }
    }, [state.join_date_from.value, state.join_date_to.value, operationErrorNotification])

    function clearJoinDateFrom() {
        onJoinDateFromChanged(null)
        setJoinFromDate('')
    }

    function clearJoinDateTo() {
        onJoinDateToChanged(null)
        setJoinToDate('')
    }


    function onResetClicked() {
        setState(stateSchema);
    }


    function onFilterClicked() {
        setAdditionalRecordList([]);
        let joinDateFrom = state.join_date_from.value ? new Date(state.join_date_from.value) : null;
        let joinDateTo = state.join_date_to.value ? new Date(state.join_date_to.value) : null;
        let joinDateFromDate = joinDateFrom ? new Date(joinDateFrom.getFullYear(), joinDateFrom.getMonth(), joinDateFrom.getDate(), 0, 0, 0) : null;
        let joinDateToDate = joinDateTo ? new Date(joinDateTo.getFullYear(), joinDateTo.getMonth(), joinDateTo.getDate(), 23, 59, 59) : null;

        setCurrentFilterParams({
            "mobilePhoneNumber": state.contact.value,
            "fullname": state.name.value,
            "joinDateFrom": state.join_date_from.value ? moment.utc(joinDateFromDate).format('YYYY-MM-DDTHH:00.000000Z') : '',
            "joinDateTo": state.join_date_to.value ? moment.utc(joinDateToDate).format('YYYY-MM-DDTHH:59.000000Z') : '',
            "email": state.email.value,
            "paymentStatus": state.payment_status.value,
            "language": state.language.value
        });
        let haveFilter = false;
        let params = {};
        if (state.name.value !== '') {
            haveFilter = true;
            params.fullname = state.name.value.toLowerCase();
        }
        if (state.contact.value !== '') {
            haveFilter = true;
            let contactKeyword = state.contact.value.replace('+', '');
            params.mobilePhoneNumber = ".*(" + contactKeyword + ")+.*";
        }
        if (state.payment_status.value !== null) {
            haveFilter = true;
            params.paymentStatus = state.payment_status.value;
        }
        if (state.email.value !== '') {
            haveFilter = true;
            let emailKeyword = state.email.value.toLowerCase();
            params.email = emailKeyword;
        }
        if (state.language.value !== 'All') {
            haveFilter = true;
            params.language = state.language.value.toLowerCase();
        }
        if (state.join_date_from.value !== null && state.join_date_to.value !== null && state.join_date_from.value !== '' && state.join_date_to.value !== '' && isDateFormat(state.join_date_from.value) && isDateFormat(state.join_date_to.value)) {
            haveFilter = true;
            let filterFromDate = moment.utc(joinDateFromDate).format('YYYY-MM-DDTHH:00.000000Z');
            let filterToDate = moment.utc(joinDateToDate).format('YYYY-MM-DDTHH:59.000000Z');
            params.createdAtStart = filterFromDate;
            params.createdAtEnd = filterToDate;
        }
        if (haveFilter) {
            setFilterParameter(params);
        }
        else {
            setFilterParameter(null);
        }
        setIsFilterClicked(true)
    }

    function onSaveClicked() {
        setIsDownloading(true)
        API.graphql({
            query: createUserListCsv,
            variables: currentFilterParams,
            authMode: 'AMAZON_COGNITO_USER_POOLS'
        })
            .then(response => {
                if (response.data.createUserListCsv) {
                    setIsDownloading(false)
                    window.open(response.data.createUserListCsv, '_blank');
                }
            }, error => {
                setIsDownloading(false)
            });
    }

    function initialise() {
        fetchUserList(false);
    }

    function handleUpperCase(event) {
        event.target.value = event.target.value.toUpperCase();
        handleChanges(event);
    }

    function _joinDateSortClicked() {
        let sortFlag = !joinDateSort;
        let sortParam = {
            field: 'createdAt',
            direction: sortFlag ? 'asc' : 'desc'
        }
        setJoinDateSort(value => sortFlag);
        setSortParameter(value => {
            return sortParam
        })
        fetchUserList(false, sortParam)
    }
    const init = throttle(initialise, 3000);
    const loadMore = throttle(fetchUserList, 3000);
    const joinDateSortClicked = throttle(_joinDateSortClicked, 3000)

    return (
        <Container maxWidth="lg" className="userlist-report-wrapper">
            <AdminMenu selected="userlist" adminGroup={props.adminGroup}></AdminMenu>
            <h4>Filter Conditions</h4>
            {operationErrorNotification ?
                <div className="form-control">
                    <div className="warning-alert-body">
                        <div className="warning-alert-box">
                            {operationErrorNotification}
                        </div>
                    </div>
                </div>
                : ''}
            <div className="form-group">
                <div className="form-control">
                    <TextField id='name' name="name" label="Full Name" value={state.name.value} onChange={handleChanges} onBlur={handleUpperCase} onFocus={filterOnFocus} variant="outlined" fullWidth />
                    {/* onBlur={this.formValidation} required  */}
                    {state.name.error ?
                        <FormHelperText error>
                            {state.name.error}
                        </FormHelperText> : ''}
                </div>
                <div className="form-control">
                    <TextField id='contact' name="contact" label="Mobile Number" value={state.contact.value} onChange={handleChanges} onFocus={filterOnFocus} onBlur={handleChanges} variant="outlined" fullWidth />
                    {/* onBlur={this.formValidation} required  */}
                    {state.contact.error ?
                        <FormHelperText error>
                            {state.contact.error}
                        </FormHelperText> : ''}
                </div>
                <div className="form-control">
                    <div className="date-picker-width">
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker id="join_date_from" name="join_date_from" label="Join Date From" value={state.join_date_from.value} inputVariant="outlined" autoOk={true}
                                onChange={onJoinDateFromChanged} onBlur={onJoinDateFromChanged} variant="inline" format='DD/MM/YYYY' onFocus={filterOnFocus} maxDate={joinToDate || undefined} />
                        </MuiPickersUtilsProvider>
                        {state.join_date_from.error ?
                            <FormHelperText error>
                                {state.join_date_from.error}
                            </FormHelperText> : ''}
                    </div>
                    <div className="date-picker-clear">
                        <Button className="date-clear-button" onClick={() => clearJoinDateFrom(null)} variant="contained" color="primary"> <ClearIcon /></Button>
                    </div>
                </div>
                <div className="form-control">
                    <div className="date-picker-width">
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker id="join_date_to" name="join_date_to" label="Join Date To" value={state.join_date_to.value} inputVariant="outlined" autoOk={true}
                                onChange={onJoinDateToChanged} onBlur={onJoinDateToChanged} variant="inline" format='DD/MM/YYYY' onFocus={filterOnFocus} minDate={joinFromDate || undefined} />
                        </MuiPickersUtilsProvider>
                        {state.join_date_to.error ?
                            <FormHelperText error>
                                {state.join_date_to.error}
                            </FormHelperText> : ''}
                    </div>
                    <div className="date-picker-clear">
                        <Button className="date-clear-button" onClick={() => clearJoinDateTo(null)} variant="contained" color="primary"> <ClearIcon /></Button>
                    </div>
                </div>
                <div className="form-control">
                    <TextField label="Email" name="email" type='email' value={state.email.value}
                        onChange={handleChanges} onBlur={handleUpperCase} variant="outlined" onFocus={filterOnFocus} fullWidth />
                    {state.email.error ?
                        <FormHelperText error>
                            {state.email.error}
                        </FormHelperText> : ''}
                </div>
                <div className="form-control select-control">
                    <FormControl variant="outlined">
                        <InputLabel>Language</InputLabel>
                        <Select variant="filled" input={<OutlinedInput />} inputProps={{ name: 'language', id: 'language-select' }} variant="outlined" value={state.language.value} onChange={handleChanges} onFocus={filterOnFocus} fullWidth>
                        <MenuItem value={'All'}>All</MenuItem>
                            <MenuItem value={'EL'}>EL</MenuItem>
                            <MenuItem value={'CH'}>CH</MenuItem>
                            <MenuItem value={'ML'}>ML</MenuItem>
                            <MenuItem value={'TL'}>TL</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className="form-control select-control">
                    <FormControl variant="outlined">
                        <InputLabel>Payment Status</InputLabel>
                        <Select variant="filled" input={<OutlinedInput />} inputProps={{ name: 'payment_status', id: 'payment_status-select' }} variant="outlined" value={state.payment_status.value} onChange={handleChanges} onFocus={filterOnFocus} fullWidth>
                            <MenuItem value={'All'}>All</MenuItem>
                            <MenuItem value={'Paid'}>Paid</MenuItem>
                            <MenuItem value={'Not Paid'}>Not Paid</MenuItem>
                            <MenuItem value={'Refunded'}>Refunded</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>

            <div className="userlist-report-button-group">
                <div className="filter-button-group">
                    {/* <Button className="filter-button grey-btn" onClick={onResetClicked}  variant="contained" color="secondary">Reset</Button> */}
                    <Button className="filter-button blue-btn" onClick={onFilterClicked} variant="contained" color="primary" disabled={!!operationErrorNotification}>Filter</Button>
                </div>
                {isFilterClicked ? <div className="download-button">
                    <Button onClick={onSaveClicked} className="grey-btn" variant="contained" color="primary">
                        {isDownloading ? (
                            <CircularProgress/>
                       ) : (
                           <label> Download csv </label>
                       )}
                    </Button>
                </div> : ""}

            </div>
            <br />
            {totalRecords ? <div className="report-total-count">Total Records: {totalRecords}</div> : ""}
            <UserList triggerJoinDateSort={joinDateSortClicked} userList={userList} loadMore={loadMore} haveNextPage={!isPageEnd} isLoading={isLoading} adminGroup={props.adminGroup} {...props}></UserList>
            <br />
        </Container>
    )
}
export default UserListReport
// export default withAuthenticator(UserListReport, false, [
//     <ConfirmSignIn />,
//     <RequireNewPassword />,
//     <SignIn />
// ])

